export default class Tool {

    public static getName(gameType):string{
        let str  = "";
        switch (gameType) {
            case 2:
                str  = "sports";//体育
                break;
            case 3:
                str  = "livevideo";//真人
                break;
            case 4:
                str  = "electronic";//电子
                break;
            case 5:
                str  = "chessandcard";//棋牌
                break;
            case 6:
                str  = "lottery";//彩票
                break;
            case 7:
                str  = "fish";//捕鱼
                break;
        }
        return str;
    }
}